import { useEffect, useMemo, useState } from 'react';
import {
  MeasurementChannelKind,
  OptimizerModeInternal,
  OptimizerScalarParameterTypeInternal,
} from '../../../../../../data-access/gql-types/graphql';
import { useMeasurementMapOperations } from '../../../../hooks/measurement-map/use-measurement-map-operations';
import { ChannelOptimizerType } from '../../../../types/channel/optimizer';
import { CurrentHookParams } from '../../meter/current/types';
import { useOptimizerModes } from '../configuration/hooks/use-optimizer-modes';
import { useOptimizerMeasurement } from './use-optimizer-measurement';

export const useOptimizerCurrent = ({ channel }: CurrentHookParams) => {
  const { convertNumberToMeasurement } = useMeasurementMapOperations();
  const { workModeOptions } = useOptimizerModes();
  const [selectedWorkMode, setSelectedWorkMode] = useState<OptimizerModeInternal>(OptimizerModeInternal.TestMode);
  const { optimizerData, measurementData } = useOptimizerMeasurement(channel);

  useEffect(() => {
    if ((channel.data as ChannelOptimizerType).payload) {
      setSelectedWorkMode((channel.data as ChannelOptimizerType).payload?.mode || OptimizerModeInternal.TestMode);
    }
  }, [channel.data]);

  const temperature = useMemo(() => {
    return (measurementData?.scalarMeasurements || []).find(
      (x) =>
        convertNumberToMeasurement(MeasurementChannelKind.Optimizer)('scalars', x.type) ===
        OptimizerScalarParameterTypeInternal.Temperature,
    )?.value;
  }, [measurementData?.scalarMeasurements]);

  const workMode = useMemo(() => {
    return workModeOptions.find((x) => x.value === selectedWorkMode)?.label || '';
  }, [selectedWorkMode]);

  return {
    optimizerData,
    measurementFullData: measurementData,
    workMode,
    temperature,
  };
};
